<div class="p-grid">
    <!-- menu bar -->
    <div class="p-col-12">
        <p-menubar [model]="menuItems">
          <ng-template pTemplate="start" style="width: 100%;">
            <h2 style="display: inline;">Mass Edit </h2>

            <span class="p-input-icon-left" style="float: right; margin: 2px 5px 0px 5px;">
              <i class="pi pi-search"></i>
              <input pInputText type="text" [(ngModel)]="globalFilterInput" (input)="onGlobalSearch()"
                placeholder="Search..." />
            </span>
            <div style="width: fit-content; float: right;">
              <p-dropdown [options]="recentItems" id="recentItems" (onChange)="recentUpdate()"
              [(ngModel)]="selectedRecent" optionLabel="name" appendTo="body" >
              </p-dropdown>
            </div>
          </ng-template>
          <ng-template pTemplate="end" style="width: 100%;">
          </ng-template>
        </p-menubar>
    </div>

    <!-- bodyArea -->
    <div class="p-col-12">
        <!-- list and split view -->
        <div class="p-grid">
            <div [ngClass]="{'p-lg-12': selectedView=='list', 'p-lg-3':selectedView=='split'}">
                <div class="card">
                    <p-contextMenu #cm [model]="configMenuItemsCM"></p-contextMenu>
                    <p-table #workflow [columns]="listColsAll" [value]="massEditData"
                    [paginator]="true" [rows]="pageSize"
                    selectionMode="single" [(selection)]="selectedMassEdit" dataKey="id" responsiveLayout="scroll"
                    (onRowSelect)="onRowSelect($event);  selectedView='split'"
                    (onRowUnselect)="selectedMassEdit = null; selectedView='list'"
                    [(contextMenuSelection)]="selectedMassEdit" [contextMenu]="cm">
                        <ng-template pTemplate="colgroup" let-columns>
                            <colgroup>
                            <ng-container *ngFor="let col of columns">
                                <col *ngIf="col.show" style="width:auto">
                            </ng-container>
                            </colgroup>
                        </ng-template>
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                              <ng-container *ngFor="let col of columns">
                                <th *ngIf="col.show" [pSortableColumn]="col.field">
                                  {{col.header}}
                                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                  </p-sortIcon>
                                  <span class="pi pi-filter p-ml-2 filtericon" [ngClass]="{'blink_me' : col.value.length > 0}"
                                    (click)="$event.stopPropagation(); curCol = col; op.toggle($event)">
                                  </span>
                                </th>
                              </ng-container>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
                              <ng-container *ngFor="let col of columns">
                                <td *ngIf="col.show" style="text-align: left;">
                                  {{rowData[col.field]}}
                                </td>
                              </ng-container>
                            </tr>
                          </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="6">{{noMEFindOrLoadingText}}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                    <p-overlayPanel #op [showCloseIcon]="false" [dismissable]="true">
                        <ng-template pTemplate>
                          <input pInputText type="text" #inputS [(ngModel)]="curCol.value"
                            (input)="workflow.filter(curCol.value, curCol.field, 'contains')"
                            placeholder="Search by {{curCol.header}}" class="p-column-filter"
                            [value]="workflow.filters[curCol.field] ? workflow.filters[curCol.field].value : ''">
                        </ng-template>
                    </p-overlayPanel>
                </div>
            </div>
            <div class="p-col-12 p-lg-9" *ngIf="selectedView == 'split' && selectedMassEdit">
                <div class="card">
                    <div class="p-grid">
                        <div class="p-col-12">
                            <p-menu #configmenu id="config_menu" [model]="configMenuItemsCM" [popup]="true"></p-menu>
                            <div class="tabviewIcons">
                                <div class="btnBars" (click)="configmenu.toggle($event)">
                                <i class="pi pi-bars"></i>
                                </div>
                                <div class="btnBars" (click)="selectedMassEdit = null; listCols = listColsAll; selectedView='list'">
                                <i class="pi pi-times"></i>
                                </div>
                            </div>
                            <p-tabView>
                                <p-tabPanel header="Overview">

                                </p-tabPanel>
                            </p-tabView>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<app-add-edit-mass></app-add-edit-mass>
